import admin from "./_admin";
import "../../setup/js/_toggleClass";
import "../../setup/js/_scaleRoot.2";
import "../../setup/js/_swiper";
import "../../setup/js/_universalLink";
import "../../setup/js/_scrollwatch";
import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
import "../../setup/js/_language";
// import "lazysizes";
// import "@fancyapps/fancybox";

window.addEventListener("load", function () {
  var url = new URL(window.location.href);
  var param_admin = url.searchParams.get("admin");
  admin.init();
  admin.executeFunctions();

  $(".loading").removeClass("active");
  scrollFrame.init();

  $("#wrapper").scalePlatform();
  $(window).on("resize", function () {
    $("#wrapper").scalePlatform();
  });
  commonLibs();

  scrollWatch.init({
    options: {
      onElementInView: function (e) {
        var $this = $(e.el).parents("[data-block-id]");
        var dataBlockId = $this.attr("data-block-id");

        //console.log(dataBlockId);
        // $(`.nav-left--item[data-fts-selector='data-block-id="${dataBlockId}"']`);
        $(`[data-fts-selector]`).removeClass("active");
        $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).addClass(
          "active"
        );
        if (
          $(
            `[data-fts-selector='[data-block-id="revelation__s27_frame_header"]']`
          ).hasClass("active")
        ) {
          $(".floatleft, .floatright").addClass("active");
        } else {
          $(".floatleft, .floatright").removeClass("active");
        }
      },
      onElementOutOfView: function (e) {
        var $this = $(e.el).parents("[data-block-id]");
        var dataBlockId = $this.attr("data-block-id");
        // console.log(dataBlockId);
        $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).removeClass(
          "active"
        );
      },
    },
  });

  $("[data-fancybox]").fancybox({
    caption: function (instance, item) {
      return $(this).find("figcaption").html();
    },
  });

  $("body")
    .find(".animate__repeat-1")
    .each(function () {
      var elementId = "#" + $(this).attr("id");
      var elementAnimate = $(this).attr("data-animate");
      scrollWatch.init({
        el: elementId,
        options: {
          watch: elementId,
          scrollThrottle: 100,
          onElementInView: function () {
            $(elementId).addClass("animate__animated");
            $(elementId).addClass(elementAnimate);
            setTimeout(function () {
              $(elementId).removeClass("animate__animated");
              $(elementId).removeClass(elementAnimate);
            }, 3000);
          },
          onElementOutOfView: function () {
            $(elementId).removeClass("animate__animated");
            $(elementId).removeClass(elementAnimate);
          },
        },
      });
    });
});

var commonLibs = function () {
  $("#wrapper").scalePlatform();

  $(".onelink").each(function () {
    $(".onelink").universalLink();
  });

  $("#navBurger").each(function () {
    $("#navBurger").toggleClassname({
      toggle: [
        {
          el: $("#floattop"),
          className: "active",
        },
        {
          el: $("#floatnav"),
          className: "active",
        },
        {
          el: $("#navBurger"),
          className: "is-active",
        },
        {
          el: $("#navBurger"),
          className: "active",
        },
      ],
    });
  });

  $("#subwebBurger").each(function () {
    $("#subwebBurger").toggleClassname({
      toggle: [
        {
          el: $(".midbar__menu"),
          className: "active",
        },
        {
          el: $("#subwebBurger"),
          className: "is-active",
        },
      ],
    });
  });

  $("#asideRightToggle").each(function () {
    $(this).toggleClassname({
      toggle: [
        {
          el: $(".floatright__main"),
          className: "active",
        },
        {
          el: $(".floatright .aside"),
          className: "active",
        },
      ],
    });
  });

  $(".scrollTop").each(function () {
    $(this).on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, 400);
    });
  });

  var target;
  var actIframe = "";
  $(".btn-openpopup").on("click", function (e) {
    target = $(this).data("target");
    $(target).toggleClass("active");
    $("html").addClass("popup-opened");
    $("#popup_content iframe").attr("src", "");
    actIframe = $(this).attr("href");
    if (actIframe == "") {
      return false;
    } else {
      $("#popup_content iframe").attr("src", actIframe);
      return false;
    }
    e.preventDefault();
  });
  $(".close").each(function () {
    $(this).on("click", function () {
      $(this).closest(".popup").removeClass("active");
      $(this).closest("section").removeClass("active");
      $("html").removeClass("popup-opened");
    });
  });
};
